const API = "https://deeply-inquisitive-lily.glitch.me";

export default API;